import React, {Component} from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik, Field, FieldArray} from 'formik';
import _ from 'lodash';
import config from '../config';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {SchedulePicker} from "../components/schedule-picker"
import {currencies} from "../components/Currencies"
import {Cohorts} from "../components/Cohorts";
import {ClientSideEvent} from "../components/EventParts/ClientSideEvent";



export default class Event extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        let {id} = this.props.match.params;
        this.state = {
            id,
            obj: null,
        };
        this.init = this.init.bind(this);
        this.save = this.save.bind(this);
        this.init(id);
    }

    async init(id) {
        this.changes = [];

        let responseProducts = await fetcher(`${config.API()}collection/products`);
        this.products = await responseProducts.json();

        let responseCohorts = await fetcher(`${config.API()}collection/cohorts`);
        this.cohorts = await responseCohorts.json();
        let responseEvents = await fetcher(`${config.API()}collection/events`);
        this.events = await responseEvents.json();
        let runtimeItems = [];

        try {
            let responseRuntime = await fetcher(`${config.API()}events/list`);
            let runtime = await responseRuntime.json();
            runtimeItems = runtime?.items || runtime?.list || [];
        } catch (runtimeErr) {
            console.error("Failed to load event runtime state", runtimeErr);
        }

        if (id == "new") {
            this.setState({
                obj: {
                    _id: "new"
                },
            })
        } else {
            let obj = _.find(this.events, x => x._id == id)
            let runtimeEvent = _.find(runtimeItems, x => x.id == id);
            if (obj && runtimeEvent) {
                obj = {
                    ...obj,
                    isActive: runtimeEvent.isActive,
                    startTime: runtimeEvent.startTime,
                    endTime: runtimeEvent.endTime,
                    sequenceId: runtimeEvent.sequenceId
                };
            }
            this.setState({obj})
        }
    }

    async save(values) {
        if (values.timeType === 'daterange') {
            delete values.weekly;
        }

        if (values.timeType === 'weekly') {
            delete values.dateRanges;
        }

        values.changes = this.changes;
        var body = JSON.stringify(values);

        fetcher(`${config.API()}collection/events/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body
        })
            .then(response => response.json())
            .then(data => {
                this.setState({redirect: `/events`});
            });
    }

    timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }
        return (
            <div>
                {this.state.obj && <Formik initialValues={this.state.obj} onSubmit={this.save}>
                    {({
                          values,
                          handleSubmit,
                          handleChange,
                          setFieldValue,
                          myHandleChange = evt => {
                              this.changes.push(evt.target.name)
                              if(evt.target.type == "number" && evt.target.value == "")
                                  evt.target.value = 0;
                              handleChange(evt);
                          },
                          isSubmitting
                      }) => (
                        <div className="card shadow w100">
                            <div className="card-header py-3">
                                <h2 className="m-0 font-weight-bold l">Event <span className="text-primary">{values.title}</span></h2>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {values._id != "new" && <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Id</label>
                                        <div className="col-sm-10">
                                            {values._id}
                                            <input className="form-control" type="hidden" name="_id" onChange={myHandleChange} value={values._id}/>
                                        </div>
                                    </div>}
                                    {values._id != "new" && <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">SequenceId (Version): </label>
                                        <div className="col-sm-10">
                                            {values.sequenceId}
                                        </div>
                                    </div>}
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Title</label>
                                        <div className="col-sm-10">
                                            <input className="form-control" type="text" name="title" onChange={myHandleChange} value={values.title}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Class</label>
                                        <div className="col-sm-10">
                                            <Field className="form-control" type="text" name="type" as="select"
                                                   onChange={evt => setFieldValue("_t", ["MagicEvent", evt.target.value])}
                                                   value={values._t && values._t[1]}>
                                                <option value="None">None</option>
                                                <option value="ClientSideEvent">ClientSideEvent</option>
                                                <option value="TournamentEvent">TournamentEvent</option>
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">GroupId</label>
                                        <div className="col-sm-10">
                                            <input type="text" name = {`groupId`} className="form-control" onChange={myHandleChange} value={values.groupId }/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">MinLevel</label>
                                        <div className="col-sm-10">
                                            <input type="number" name = {`minLevel`} className="form-control" onChange={myHandleChange} value={values.minLevel }/>
                                        </div>
                                    </div>
                                    {values._t && values._t[1] == "ClientSideEvent" && <ClientSideEvent  values={values} myHandleChange={myHandleChange} setFieldValue={setFieldValue} />}

                                    <Cohorts name="cohortIds" cohorts={this.cohorts} cohortIds={values.cohortIds} setFieldValue={setFieldValue}/>
                                    <SchedulePicker values={values} handleChange={myHandleChange} handleChangeState={(item) => {
                                        this.changes.push("SchedulePicker")
                                        this.setState({item})
                                    }}/>
                                    <button type="submit" className="btn btn-icon btn-success ml-1 r mt-3"><span className="fas fa-fw fa-save"></span>Save</button>
                                </form>
                            </div>
                        </div>
                    )}
                </Formik>}
            </div>
        );
    }
}
